import {
    novoBeneficio,
    novoPlano,
    type ClubeBeneficiosModel,
    type PlanoClubeForm,
} from "../models/clubeBeneficiosModel"
import {
    ClubeBeneficiosActionsTypes,
    type ClubeBeneficiosActionModel,
} from "./clubeBeneficiosActions"

function atualizarPlano(
    state: ClubeBeneficiosModel,
    chavePlano: string,
    alterar: (plano: PlanoClubeForm) => PlanoClubeForm
): ClubeBeneficiosModel {
    return {
        ...state,
        planos: state.planos.map(p => (p.chave === chavePlano ? alterar(p) : p)),
    }
}

export function clubeBeneficiosReducer(
    state: ClubeBeneficiosModel,
    action: ClubeBeneficiosActionModel
): ClubeBeneficiosModel {
    switch (action.type) {
        case ClubeBeneficiosActionsTypes.CARREGAR:
            return { ...action.payload }

        case ClubeBeneficiosActionsTypes.ADICIONAR_PLANO:
            return {
                ...state,
                planos: [...state.planos, novoPlano(state.proximaChave)],
                proximaChave: state.proximaChave + 1,
            }

        case ClubeBeneficiosActionsTypes.REMOVER_PLANO: {
            const removido = state.planos.find(p => p.chave === action.payload.chavePlano)
            if (!removido) return state
            return {
                ...state,
                planos: state.planos.filter(p => p.chave !== action.payload.chavePlano),
                // Plano já salvo só é excluído no backend ao salvar (deletarClubeIds).
                planosExcluidos: removido.id
                    ? [...state.planosExcluidos, removido]
                    : state.planosExcluidos,
            }
        }

        case ClubeBeneficiosActionsTypes.RESTAURAR_PLANOS_EXCLUIDOS:
            if (state.planosExcluidos.length === 0) return state
            return {
                ...state,
                planos: [...state.planos, ...state.planosExcluidos],
                planosExcluidos: [],
            }

        case ClubeBeneficiosActionsTypes.MOVER_PLANO: {
            const { chavePlano, direcao } = action.payload
            const de = state.planos.findIndex(p => p.chave === chavePlano)
            const para = de + direcao
            if (de < 0 || para < 0 || para >= state.planos.length) return state
            const planos = [...state.planos]
            ;[planos[de], planos[para]] = [planos[para], planos[de]]
            return { ...state, planos }
        }

        case ClubeBeneficiosActionsTypes.ATUALIZAR_CAMPO: {
            const { chavePlano, campo, valor } = action.payload
            return atualizarPlano(state, chavePlano, p => ({ ...p, [campo]: valor }))
        }

        case ClubeBeneficiosActionsTypes.ADICIONAR_BENEFICIO:
            return atualizarPlano(state, action.payload.chavePlano, p => ({
                ...p,
                beneficios: [...p.beneficios, novoBeneficio(p.proximaChave, action.payload.tipo)],
                proximaChave: p.proximaChave + 1,
            }))

        case ClubeBeneficiosActionsTypes.ATUALIZAR_BENEFICIO: {
            const { chavePlano, chave, campo, valor } = action.payload
            return atualizarPlano(state, chavePlano, p => ({
                ...p,
                beneficios: p.beneficios.map(b =>
                    b.chave === chave ? { ...b, [campo]: valor } : b
                ),
            }))
        }

        case ClubeBeneficiosActionsTypes.REMOVER_BENEFICIO: {
            const { chavePlano, chave } = action.payload
            return atualizarPlano(state, chavePlano, p => {
                const removido = p.beneficios.find(b => b.chave === chave)
                if (!removido) return p
                return {
                    ...p,
                    beneficios: p.beneficios.filter(b => b.chave !== chave),
                    deletarBeneficioIds:
                        removido.id && !p.deletarBeneficioIds.includes(removido.id)
                            ? [...p.deletarBeneficioIds, removido.id]
                            : p.deletarBeneficioIds,
                }
            })
        }

        default:
            return state
    }
}
